import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { CancelTokenSource } from "axios";

import { SelectOption } from "src/app/modals/CreateNewProjectPane/types";
import { RootState } from "src/redux/reducers";
import { SearchResultsService } from "src/services";
import SearchSelect from "../SearchSelectDropdown/SearchSelectDropdown";

interface ProjectsSearchSelectorProps {
  id?: string;
  value: SelectOption | null;
  handleChange: (newOption: SelectOption) => void;
  placeholder: string;
  activeProjectUuid?: string;
  afterMenuList?: ReactNode;
}

export default function ProjectsSearchSelector({
  id,
  value,
  placeholder,
  handleChange,
  activeProjectUuid,
  afterMenuList,
}: ProjectsSearchSelectorProps) {
  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const handleLoadOptions = async (
    inputValue: string,
    cancelToken: CancelTokenSource,
  ) => {
    const options = await SearchResultsService.getProjects(
      activeWorkspaceUuid,
      [inputValue],
      cancelToken,
    );
    return options
      .filter((project) => project.wsProjectUuid !== activeProjectUuid)
      .map((project) => ({
        value: project.wsProjectUuid,
        label: project.wsProjectName,
      }));
  };

  return (
    <SearchSelect<SelectOption>
      id={id}
      value={value}
      placeholder={placeholder}
      handleChange={handleChange}
      fetchOptions={handleLoadOptions}
      afterMenuList={afterMenuList}
    />
  );
}
